export default "/7ee56fc642439642e071ad6692a1a8b95a874bf4/d9f26165e744ef064b81249371ce3c44.svg";